import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import classes from "./Logins.module.css";
import logo from "./../../assets/icons/Logo_register.png";
import LoginWithUsernameForm from "../../components/loginComponents/LoginWithUsernameForm";
import LoginWithPhoneForm from "../../components/loginComponents/LoginWithPhoneForm";
import toast from "react-hot-toast";

function Logins() {
  const [isLoggingWithUser, setIsLoggingWithUser] = useState(true);
  const [loginFailed, setLoginFailed] = useState(false);
  const [usernameInput, setUsernameInput] = useState("");
  const [phoneInput, setPhoneInput] = useState("");
  const [passInput, setPassInput] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility

  const navigate = useNavigate();

  const trueLogin = () => setIsLoggingWithUser(true);
  const falseLogin = () => setIsLoggingWithUser(false);

  const setLoginOption = (arg1, pass) => {
    if (isLoggingWithUser) {
      setUsernameInput(arg1);
    } else {
      setPhoneInput(arg1);
    }
    setPassInput(pass);
  };

  const chooseAPI = () => {
    return `${process.env.REACT_APP_API_URL}/api/v1/user/login`;
  };

  const resetForm = () => {
    setUsernameInput("");
    setPhoneInput("");
    setPassInput("");
  };

  const loginSubmitted = () => {
    setIsButtonDisabled(true);

    const urlencoded = new URLSearchParams();
    urlencoded.append("password", passInput);
    urlencoded.append("username", String(usernameInput));

    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: urlencoded,
      redirect: "follow",
    };

    fetch(chooseAPI(), requestOptions)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(JSON.stringify(err));
          });
        }
        return response.json();
      })
      .then((respObj) => {
        if (respObj && respObj.data) {
          const { token, refresh_token } = respObj.data;

          if (token) {
            const date = new Date();
            const time = date.getTime();
            localStorage.setItem("token", token);
            localStorage.setItem("refresh_token", refresh_token);
            localStorage.setItem("tokenSetTime", time);
            localStorage.setItem("username", usernameInput);
            navigate("/", { state: { Object: respObj } });
          } else {
            setLoginFailed(true);
            toast.error(
              "خطا در روند ورود شما رخ داده است لطفا مجددا امتحان کنید"
            );
          }
        } else {
          setLoginFailed(true);
          toast.error(
            "خطا در روند ورود شما رخ داده است لطفا مجددا امتحان کنید"
          );
        }
        resetForm();
      })
      .catch((error) => {
        setLoginFailed(true);
        try {
          const parsedError = JSON.parse(error.message);
          if (parsedError && parsedError.error) {
            toast.error(
              parsedError.error.description || "Unknown error occurred"
            );
          } else {
            toast.error("خطا رخ داده است با پشتیبانی تماس بگیرید");
          }
        } catch (e) {
          toast.error("خطا رخ داده است با پشتیبانی تماس بگیرید");
        }
      })
      .finally(() => {
        setIsButtonDisabled(false);
      });
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className={classes.container}>
      <div className={classes.section_logo}>
        <img className={classes.logo_img} alt="Logo" src={logo} />
      </div>
      <div className={classes.section_form}>
        {isLoggingWithUser ? (
          <LoginWithUsernameForm setLoginOption={setLoginOption} />
        ) : (
          <LoginWithPhoneForm setLoginOption={setLoginOption} />
        )}
        <div className={classes.buttons_Container}>
          <button
            onClick={loginSubmitted}
            className={classes.submitButton}
            disabled={isButtonDisabled}
            style={{
              backgroundColor: isButtonDisabled ? "#495057" : "",
              cursor: isButtonDisabled ? "not-allowed" : "pointer",
              border: isButtonDisabled ? "none" : "",
            }}
          >
            {isButtonDisabled ? " لطفا منتظر بمانید ..." : "ورود"}
          </button>
          <div className={classes.top}>
            <button
              className={classes.recieve_SMS}
              onClick={() => navigate("/loginWithPhone")}
            >
              ورود با شماره موبایل
            </button>
            <button
              onClick={() => {
                resetForm();
                navigate("/Register");
              }}
              className={classes.registerButton}
            >
              ثبت نام
            </button>
          </div>
          <div className={classes.forgetPassword}>
            <u onClick={handleShow} style={{ cursor: "pointer" }}>
              رمز عبور خود را فراموش کرده اید؟
            </u>
          </div>
        </div>
      </div>

      {/* Modal for Password Reset */}
      <Modal style={{ direction: "rtl" }} show={showModal} onHide={handleClose}>
        {/* <Modal.Header>
          <h4>فراموشی رمز عبور</h4>
        </Modal.Header> */}
        <Modal.Body>
          <h4 style={{ fontSize: "17px" }}>
            در صورت فراموشی رمز عبور می توانید از گزینه "ورود با شماره موبایل "
            وارد شوید سپس از قسمت تنظیمات رمز خود را تغییر دهید{" "}
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-dark" onClick={handleClose}>
            ادامه{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Logins;
